import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { tr } from "@/lib/i18n";
import { Loader2 } from "lucide-react";

export default function StepPostponeDialog({ goalId, step, onClose, onDone }) {
  const { lang } = useAuth();
  const t = (k) => tr(k, lang);
  const [newDue, setNewDue] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (step) setNewDue(step.due?.slice(0, 10) || "");
  }, [step]);

  if (!step) return null;

  const submit = async () => {
    setSaving(true);
    try {
      const r = await api.patch(
        `/career/goals/${goalId}/steps/${step.step_id}`,
        { due: newDue || null }
      );
      toast.success(t("ops.postpone.saved"));
      onDone?.(r.data);
      onClose?.();
    } catch { toast.error(t("step.save_fail")); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!step} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent data-testid="step-postpone-dialog"
        className="max-w-md bg-stone-950 border-stone-800">
        <DialogHeader>
          <DialogTitle className="serif text-2xl text-stone-100">
            {t("step.postpone.title")}
          </DialogTitle>
        </DialogHeader>

        <div className="mt-2 space-y-3">
          <p className="text-stone-300 text-sm">{t("ops.postpone.q")}</p>
          <div className="serif text-lg text-stone-200 italic">„{step.name}”</div>
          <input
            data-testid="step-postpone-date"
            type="date"
            value={newDue}
            onChange={(e) => setNewDue(e.target.value)}
            className="script-input w-full"
          />
        </div>

        <div className="flex items-center justify-end gap-2 pt-4 flex-wrap">
          <button onClick={onClose} className="ghost-btn">{t("action.cancel")}</button>
          <button
            onClick={submit}
            data-testid="step-postpone-save"
            disabled={saving}
            className="pill-btn"
          >
            {saving ? <Loader2 size={14} className="animate-spin" /> : null}
            {t("ops.postpone.save")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
